import './cards';
import './modals';
import './splash';

// IE doesn't know about forEach()
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

//page loaded let's go!
document.addEventListener("DOMContentLoaded", () => {
	// fade out content before going to next page
	// window.addEventListener('beforeunload', function() {
	// 	document.querySelectorAll('.container').classList.add('fadeout');
	// });

	//Audio player buttons
	if (document.querySelector('.audio-toggle')) {
		document.querySelector('.audio-toggle').addEventListener('click', function() {
			const player = videojs.getPlayer(this.getAttribute('data-player')),
                image = this.querySelector('img');
            player.fill(true);
			if (!player.paused()) {
                image.src = '/assets/images/ui/audio-play.svg';
				player.pause();
				player.controlBar.addClass('vjs-hide');
			} else {
                image.src = '/assets/images/ui/audio-pause.svg';
				player.play();
				player.controlBar.removeClass('vjs-hide');
			}
		});
	}

	// Mobile nav on/off
	document.getElementById('mobile-burger').addEventListener('click', function() {
		document.querySelector('.mobile-nav').style['display'] = 'block';
		document.querySelector('.mobile-nav').classList.remove('is-disabled');
		document.querySelector('.layout--right').style['display'] = 'none';
	});
	document.querySelector('.mobile-nav--close').addEventListener('click', function() {
		document.querySelector('.mobile-nav').style['display'] = 'none';
		document.querySelector('.mobile-nav').classList.add('is-disabled');
		document.querySelector('.layout--right').style['display'] = 'block';
	});	

    const formSubscribe = document.querySelector('#form-subscribe');
    formSubscribe.addEventListener('submit', event => {
        event.preventDefault();
        const formData = new FormData(formSubscribe);

        axios.post('/', formData)
            .then(function (response) {
                if (response.data.errors) {// display errors
                    let errorsHTML = '',
                        errors = Object.values(response.data.errors);
                    for(let i = 0; i < errors.length; i++) {
                        errorsHTML += '<p class="err">'+ errors[i] +'</p>';
                    }
                    document.querySelector(".errors").innerHTML = errorsHTML;
                } else {// display thank you
                    document.getElementById("form-subscribe").innerHTML = '<div><h3>Thank you!</h3><p>Thank you for your subscription.</p></div>';
                }
            })
            .catch(function (error) {
                document.getElementById("form-subscribe").innerHTML = '<div><h3>Sorry, there was an error.</h3><p>The following errors were encountered:</p><p>'+ error +'</p></div>';
            });
    });

    const formSearch = document.querySelector('#form-search');
    formSearch.addEventListener('submit', event => {
        let query = formSearch.querySelector('#q');
        if (!query.value || query.value == '') {
            event.preventDefault();
            formSearch.querySelector(".errors").innerHTML = '<p class="err">Please give us a hint of what you are looking for.</p>';
        }
    });
});

